import {connect} from 'react-redux';
import TournamentList from './TournamentList.jsx';
import {
  handleManageClick, 
  handleCopyClick
} from './actions';

const mapStateToProps = state => ({
  ...state.tournament.tournamentList,
  groupName: state.shared.auth.groupName,
  isAllowed: state.shared.auth.isAllowed
});

const mapDispatchToProps = dispatch => ({
  onManageClick: tournamentId => dispatch(handleManageClick(tournamentId)),
  onCopyClick: tournamentId => dispatch(handleCopyClick(tournamentId))
});

export default connect(mapStateToProps, mapDispatchToProps)(TournamentList);



// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/TournamentListContainer.jsx